// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"a7398a53","764":"cf055aea","911":"7fceac93"}[chunkId] + ".chunk.js";
};